import service from '@/store/services/func_element-service';

const state = {
    funcElementList: {},
    newFuncElement: {},
    funcTranslates: {}
};

const mutations = {
    SET_FUNCTION_ELEMENT_LIST: (state, funcElementList) => {
        state.funcElementList = funcElementList;
    },
    SET_NEW_FUNCTION_ELEMENT: (state, newFuncElement) => {
        state.newFuncElement = newFuncElement;
    },
    GET_FUNCTION_TRANSLATES: (state, funcTranslates) => {
        state.funcTranslates = funcTranslates;
    },

};

const actions = {
    funcElementList({commit}) {
        return service.getFuncElementList()
            .then(({funcElementList}) => {
                commit('SET_FUNCTION_ELEMENT_LIST', funcElementList);
            });
    },
    newFuncElement({commit, dispatch}, params) {
        return service.addNewFuncElement(params)
            .then(({newFuncElement}) => {
                commit('SET_NEW_FUNCTION_ELEMENT', newFuncElement);
            });
    },
    funcTranslates({commit}, params) {
        return service.getFuncTranslates( params)
            .then(({funcTranslates}) => {
                commit('GET_FUNCTION_TRANSLATES', funcTranslates);
            });
    },

};

const getters = {
    funcElementList: state => state.funcElementList,
    newFuncElement: state => state.newFuncElement,
    funcTranslates: state => state.funcTranslates,
};

const funcElements = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default funcElements;